import { tableToFormSchema } from '../../helpers'
import { getColumns } from './getColumns'
import { TableContent } from './TableContent'
import { useGetTable } from './useGetTable'
import { Skeleton } from '@/components/shadcn/skeleton'
import { useTileFilterSelections } from '../../../hooks/useTileFilterSelections'

// setFiltersSelectionsPersisted(
//   Object.entries(data).map(([key, value]) => ({
//     [key]: value,
//   }))
// )

export function DataTableComponent({ id }: { id: string }) {
  const { data } = useGetTable(id, [])
  const { tileFilterSelections, filterChangeHandler } = useTileFilterSelections(data.filters)

  // Refetch with filters applied
  const dataWithFilters = useGetTable(id, tileFilterSelections).data

  type TableDataType = (typeof dataWithFilters)['dataSchema']['data'][number]
  const columns = getColumns<TableDataType>(dataWithFilters.uiSchema)
  const { canCreate, canEdit } = dataWithFilters.uiSchema.tableConfig.permissions

  return (
    <TableContent
      data={dataWithFilters.dataSchema.data}
      columns={columns}
      tableConfig={dataWithFilters.uiSchema.tableConfig}
      formSchema={canCreate || canEdit ? tableToFormSchema(dataWithFilters.uiSchema) : undefined}
      tileFilterSchema={dataWithFilters.filters}
      filterChangeHandler={filterChangeHandler}
    />
  )

  // return <TableContent />
}
